import axios from 'axios';

const BrokerService = {
  async getBrokers() {
    const response = await axios.get('/brokers');

    return response.data;
  },

  async getBrokerById(id) {
    const response = await axios.get(`/brokers/${id}`);

    return response.data;
  },

  async updateBroker({ formValues, id }) {
    const response = await axios.patch(`/brokers/${id}`, formValues);

    return response.data;
  },

  async getBrokerUsers({ id, role }) {
    const response = await axios.get(`/brokers/${id}/users`, {
      params: { role },
    });

    return response.data;
  },

  async getBrokerBrokerTeams(id) {
    const response = await axios.get(`/brokers/${id}/broker-teams`);

    return response.data;
  },
};

export default BrokerService;
